import { Component, OnDestroy, Input, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Utente, FiguraProfessionaleDiRiferimentoInformazioniAnagraficheSipiRow } from '@gpi/lbl/shared/entity';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'lbl-app-feature-sipi-sezione-raccolta-informazioni-dialog-form-professionista',
  templateUrl: 'dialog-form-professionista.component.html',
  styleUrls: ['dialog-form-professionista.component.scss'],
})
export class DialogFormProfessionistaComponent {

  submit$: Subject<void> = new Subject();

  constructor(
    private matDialogRef: MatDialogRef<DialogFormProfessionistaComponent>,
    @Inject(MAT_DIALOG_DATA) public form: FormGroup
  ) { }

  cancel() {
    this.matDialogRef.close();
  }

  continue() {
    this.matDialogRef.close(this.form);
  }
}
